export default __webpack_public_path__ + "static/media/24_hours_support.0e989773.svg";